import qualifications from "./qualifications";

export const QUALIFICATIONS_NAMESPACE = `users/qualifications`;

export default qualifications;
